import {AfterViewInit, Component, computed, inject, OnInit, viewChild} from '@angular/core';
import { SelectComponent } from '../../../../shared/components/select/select.component';
import { LookupStore } from '../../../../shared/store/lookup.store';
import {LookupTabBase} from '../../lookup-tab-base';
import {ButtonComponent} from '../../../../shared/components/button/button.component';
import {FormsModule} from '@angular/forms';
import {Form} from '../../../../shared/components/form/form';
import {PostHogService} from '../../../../shared/services/posthog.service';

@Component({
  selector: 'app-lookup-by-size',
  imports: [SelectComponent, ButtonComponent, FormsModule, Form],
  templateUrl: './lookup-by-size.html',
  styleUrl: './lookup-by-size.css'
})
export class LookupBySize extends LookupTabBase implements OnInit, AfterViewInit {
  lookupStore = inject(LookupStore);
  private posthogService = inject(PostHogService);

  widthSelect = viewChild.required<SelectComponent>('widthSelect');
  ratioSelect = viewChild.required<SelectComponent>('ratioSelect');
  diameterSelect = viewChild.required<SelectComponent>('diameterSelect');

  categories = [
    { label: 'All', value: null },
    { label: 'Retail', value: 'retail' },
    { label: 'Commercial', value: 'commercial' }
  ];

  ngOnInit() {
    if (!this.lookupStore.size.widths()) {
      this.lookupStore.loadWidths(null);
    }
  }

  ngAfterViewInit() {
    this.widthSelect().focus();
  }

  readonly widths = computed(() => this.lookupStore.size.widths()?.map(width => ({ label: width, value: width })) ?? []);
  readonly ratios = computed(() => this.lookupStore.size.ratios()?.map(ratio => ({ label: ratio, value: ratio })) ?? []);
  readonly diameters = computed(() => this.lookupStore.size.diameters()?.map(diameter => ({ label: diameter, value: diameter })) ?? []);
  readonly ratiosDisabled = computed(() => !this.lookupStore.size.selected_width());
  readonly diametersDisabled = computed(() => !this.lookupStore.size.selected_ratio());
  readonly isValid = computed(() => !!(this.lookupStore.size().selected_width && this.lookupStore.size().selected_diameter));

  onWidthChange(width: string) {
    if (width === this.lookupStore.size.selected_width()) return;
    this.ratioSelect().focus();
    this.lookupStore.setWidth(width);
  }

  onRatioChange(ratio: string) {
    if (ratio === this.lookupStore.size.selected_ratio()) return;
    this.diameterSelect().focus();
    this.lookupStore.setRatio(ratio);
  }

  onDiameterChange(diameter: string) {
    if (diameter === this.lookupStore.size.selected_diameter()) return;
    this.lookupStore.setDiameter(diameter);
  }

  submit() {
    if (this.isValid()) {
      const size = this.lookupStore.size();
      this.posthogService.posthog.capture('tire_search_by_size', {
        width: size.selected_width,
        ratio: size.selected_ratio,
        diameter: size.selected_diameter,
      });

      const ratio = size.selected_ratio?.includes('.') ? String(parseFloat(size.selected_ratio) * 100) : (size.selected_ratio ?? '');
      this.search.emit({rawsize: `${size.selected_width}${ratio}${size.selected_diameter}`});
    }
  }
}
